import { createFileRoute } from "@tanstack/react-router";
import AdminPartsCategories from "@/pages/admin/AdminPartsCategories";

export const Route = createFileRoute("/_adminLayout/admin/parts/categories/")({
  component: AdminPartsCategories,
});